/*
 *   Copyright (c) 2026 
 *   All rights reserved.
 */
import React from 'react';
import './Footer.css';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerHeight = 80;
      const targetPosition = element.offsetTop - headerHeight;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="footer" itemScope itemType="http://schema.org/LocalBusiness">
      <div className="container">
        <div className="footer-content">
          <div className="footer-col">
            <h4 itemProp="name">Thaqi Prospektvertrieb Hannover</h4>
            <p itemProp="description">
              Professionelle <strong>und zuverlässige Prospektverteilung in Hannover, Hildesheim & Hameln</strong> und Umgebung. 
              Ihr Partner für <strong>Haushaltswerbung</strong>, <strong>Direktmarketing</strong> und 
              Qualität durch lokale Expertise seit über 10 Jahren.
            </p>
            <meta itemProp="url" content="https://thaqiprospektvertrieb.de" />
          </div>
          
          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#hero" onClick={(e) => { e.preventDefault(); scrollToSection('hero'); }}>Home</a></li>
              <li><a href="#leistungen" onClick={(e) => { e.preventDefault(); scrollToSection('leistungen'); }}>Leistungen</a></li>
              <li><a href="#ueber-uns" onClick={(e) => { e.preventDefault(); scrollToSection('ueber-uns'); }}>Über uns</a></li>
              <li><a href="#verteilgebiete" onClick={(e) => { e.preventDefault(); scrollToSection('verteilgebiete'); }}>Verteilgebiete</a></li>
              <li><a href="#kontakt" onClick={(e) => { e.preventDefault(); scrollToSection('kontakt'); }}>Kontakt</a></li>
            </ul>
          </div>
          
          <div className="footer-col">
            <h4>Einsatzgebiete</h4>
            <ul>
              <li><a href="#verteilgebiete" onClick={(e) => { e.preventDefault(); scrollToSection('verteilgebiete'); }} title="Prospektverteilung Hannover">Prospektverteilung Hannover</a></li>
              <li><a href="#verteilgebiete" onClick={(e) => { e.preventDefault(); scrollToSection('verteilgebiete'); }} title="Prospektverteilung Garbsen">Prospektverteilung Garbsen</a></li>
              <li><a href="#verteilgebiete" onClick={(e) => { e.preventDefault(); scrollToSection('verteilgebiete'); }} title="Prospektverteilung Laatzen">Prospektverteilung Laatzen</a></li>
              <li><a href="#verteilgebiete" onClick={(e) => { e.preventDefault(); scrollToSection('verteilgebiete'); }} title="Prospektverteilung Langenhagen">Prospektverteilung Langenhagen</a></li>
              <li><a href="#verteilgebiete" onClick={(e) => { e.preventDefault(); scrollToSection('verteilgebiete'); }} title="Prospektverteilung Barsinghausen">Prospektverteilung Barsinghausen</a></li>
            </ul>
          </div>
          
          <div className="footer-col">
            <h4>Kontakt</h4>
            <div itemProp="address" itemScope itemType="http://schema.org/PostalAddress">
              <p>
                <strong>Thaqi Prospektvertrieb</strong><br />
                <span itemProp="addressLocality">Hannover</span>, <span itemProp="addressRegion">Niedersachsen</span><br />
                <span itemProp="postalCode">30159</span> <span itemProp="addressCountry">Deutschland</span><br />
                Tel: <a href="tel:+4917623364770" itemProp="telephone">+49 176 23364770</a><br />
                E-Mail: <a href="mailto:dritonthaqi1980@outlook.com" itemProp="email">dritonthaqi1980@outlook.com</a>
              </p>
            </div>
            <meta itemProp="priceRange" content="€€" />
            <meta itemProp="openingHours" content="Mo-Fr 08:00-18:00" />
          </div>
        </div>
        
        <div className="footer-links">
          <h4>Rechtliches</h4>
          <ul className="legal-links">
            <li><a href="/impressum">Impressum</a></li>
            <li><a href="/datenschutz">Datenschutz</a></li>
          </ul>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2026 <strong>Thaqi Prospektvertrieb Hannover</strong>. Alle Rechte vorbehalten.</p>
          <p className="footer-seo">
            <strong>Prospektverteilung Hannover</strong> | <strong>Flyerverteilung Hannover</strong> | 
            <strong>Haushaltswerbung</strong> | <strong>Direktmarketing Hannover</strong> | 
            <strong>Prospektverteiler Garbsen</strong> | <strong>Flyer verteilen Laatzen</strong>
          </p>
          <p className="footer-resources">
            Nützliche Ressourcen: <a href="https://www.ihk-hannover.de" target="_blank" rel="noopener noreferrer">IHK Hannover</a> | 
            <a href="https://www.hannover.de" target="_blank" rel="noopener noreferrer">Stadt Hannover</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
